/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  deleteTemplate(inboxId, templateSid) {
    return axios.delete(`${this.url}/${inboxId}/delete_template`, {
      data: { template_sid: templateSid },
    });
  }

  createTemplate(inboxId, templateData) {
    return axios.post(`${this.url}/${inboxId}/create_template`, {
      template_data: templateData,
    });
  }

  applyForTemplateApproval(inboxId, templateSid, templateName, category) {
    return axios.post(`${this.url}/${inboxId}/apply_for_template_approval`, {
      template_sid: templateSid,
      template_name: templateName,
      category: category,
    });
  }
}

export default new Inboxes();
